import JSIBase from "./base";
import {route, routes} from "../rd";
import {toQueryFromObject} from "../../modules/func";

export default class JSIDefault extends JSIBase {
    /**
     * 로그인
     * @param id 아이디
     * @param pw 비밀번호
     */
    jsi_login(id, pw)
    {
        route(routes.login_process + '?' + toQueryFromObject({id, pw}));
    }

    jsi_get_info() {
        return super.jsi_get_info();
    }
}


// WEBPACK FOOTER //
// ./src/vars/interfaces/default.js